// Basit Üretim Reçeteleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.productRecipesPage';

export const productRecipesPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Basit Üretim Reçeteleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Satıldığında malzemeleri stoktan düşen ürünlerin reçetelerini bu sayfada tek yerden görür, açar ve maliyetlerini izlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Reçete kartları'),
    filters: t(`${G}.regions.filters`, 'Arama, şube ve durum'),
    toolbar: t(`${G}.regions.toolbar`, 'İşlem düğmeleri'),
    table: t(`${G}.regions.table`, 'Reçete listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Reçetesi olan bir ürün satıldığında, reçetedeki malzemeler stoktan otomatik düşer. Reçeteyi stok listesinde ürünün satır menüsündeki "Basit Üretim" ile oluşturursunuz; bu sayfa tüm reçeteleri bir arada gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Satışta her malzeme "satış miktarı × reçetedeki miktar" kadar, satışın yapıldığı depodan düşülür.'),
        t(`${G}.s1.tip2`, 'Pasif reçete satışta malzeme düşürmez.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Toplam Reçete, Aktif Reçete, Pasif Reçete ve Toplam Malzeme Satırı kartları reçetelerinizin genel durumunu gösterir.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Arayın, şube ve durum seçin'),
      text: t(`${G}.s3.text`, 'Arama kutusuna reçete adı, reçete kodu, ürün adı veya stok kodu yazın. "Durum" ile yalnız aktif ya da pasif reçeteleri listeleyin; "Filtreyi Temizle" seçimleri sıfırlar.'),
      tips: [
        t(`${G}.s3.tip1`, '"Maliyet Şubesi" seçerseniz Maliyet sütunu malzemelerin o şubedeki alış fiyatıyla hesaplanır. Boş bırakılırsa şirket geneli (ürün kartı fiyatı) kullanılır.'),
        t(`${G}.s3.tip2`, 'Seçtiğiniz maliyet şubesi, açtığınız reçete penceresine de aynen geçer.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. İşlem düğmeleri'),
      text: t(`${G}.s4.text`, '"Stok Listesi" stok ekranına döner, "Excel İndir" o an sayfada görünen reçeteleri Excel dosyasına aktarır, yenile düğmesi listeyi tazeler.'),
      tips: [
        t(`${G}.s4.tip1`, '"Reçeteleri yeniden hesapla": tüm reçetelerin stoktan düşülecek malzeme listesi yeniden hesaplanır. Satışları etkilemez, yalnız listeyi güncel kurallara göre tazeler. Bu düğme üretim modülü açıkken ve şube yöneticisi olmayan kullanıcılarda görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Reçeteyi açın ve düzenleyin'),
      text: t(`${G}.s5.text`, 'Bir satıra veya satırdaki "Reçeteyi Aç" (kalem) düğmesine tıklayın; reçete penceresi açılır. Malzeme ekleme, miktar ve fire ayarı orada yapılır; pencerenin kendi rehberi vardır. Kaydettiğinizde liste ve kartlar yenilenir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Sütunları okuyun'),
      text: t(`${G}.s6.text`, 'Çıktı, reçetenin kaç birim ürün verdiğini; Malzeme, reçetedeki malzeme sayısını gösterir. Maliyet sütununda toplam maliyet ve altında birim başına maliyet yer alır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Maliyette "-" görünüyorsa reçeteye malzeme tanımlanmamıştır.'),
        t(`${G}.s6.tip2`, 'Uyarı simgesi: bazı malzemelerin alış fiyatı TL değil; maliyete çevrilmeden toplanmıştır.'),
        t(`${G}.s6.tip3`, 'Eksi Stok sütunu reçetenin eksi stok ayarını (İzinli / Kapalı), Durum sütunu Aktif / Pasif bilgisini gösterir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına kaç satır görüneceğini seçin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
